export default "__VITE_ASSET__Dgh$GNX4__"